import React from "react";
import { Tooltip } from "@mantine/core";
import PropTypes from "prop-types";

// Use this instead of the native title attribute, which the browser shows after a slow, fixed delay.
// Renders the children as-is when disabledHoverText is falsy.
// "\n" in disabledHoverText is shown as a line break.
// Any other props are passed through to the mantine Tooltip (position, openDelay, w, etc.)
// A styles prop is merged into the default styles below instead of replacing them.
const LexWorkplaceTooltip = ({
	disabledHoverText,
	children,
	styles = {},
	...tooltipProps
}) => {
	if (!disabledHoverText) {
		return children;
	}
	return (
		<Tooltip
			label={disabledHoverText}
			multiline
			maw={400}
			withArrow
			arrowSize={6}
			{...tooltipProps}
			styles={{
				...styles,
				tooltip: {
					whiteSpace: "pre-line",
					fontSize: "12px",
					...styles.tooltip,
				},
				// the arrow is a separate element, so it needs its own border to match the tooltip
				arrow: {
					...styles.arrow,
				},
			}}
		>
			{children}
		</Tooltip>
	);
};

LexWorkplaceTooltip.propTypes = {
	disabledHoverText: PropTypes.string,
	// mantine styles object, e.g. { tooltip: {...}, arrow: {...} }
	styles: PropTypes.object,
	// mantine Tooltip needs a single child element that can hold a ref (e.g. a div)
	children: PropTypes.element.isRequired,
};

export default LexWorkplaceTooltip;
